<div class="main-content">
	<div class="container-fluid">
		<div class="row tp-wrapper m-0 p-0">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title">
							<i class="material-icons">auto_awesome</i> Vendor Intake
						</h4>
						<div class="cmi-header-actions" *ngIf="section === 'credit' && queue.length">
							<span class="cmi-counter" *ngIf="posting || postTotal">
									{{ postedCount + failedCount }} / {{ postTotal }} {{ runMode === 'dry' ? 'previewed' : 'posted' }}
									<span class="cmi-counter-fail" *ngIf="failedCount"> · {{ failedCount }} {{ runMode === 'dry' ? 'need review' : 'failed' }}</span>
							</span>
								<button mat-stroked-button [disabled]="posting || !readyCount" (click)="dryRunAll()">
									<mat-icon>fact_check</mat-icon> Preview ({{ readyCount }})
							</button>
							<button mat-raised-button color="accent" [disabled]="posting || !readyCount" (click)="postAllReady()">
								<mat-icon>bolt</mat-icon> Post all ready ({{ readyCount }})
							</button>
							<button mat-button [disabled]="posting" (click)="clearQueue()">Clear</button>
						</div>
						<div class="cmi-header-actions" *ngIf="section === 'invoice' && vinvQueue.length">
							<span class="cmi-counter" *ngIf="vinvPosting || vinvTotal">
									{{ vinvPosted + vinvFailed }} / {{ vinvTotal }} {{ vinvRunMode === 'dry' ? 'previewed' : 'posted' }}
									<span class="cmi-counter-fail" *ngIf="vinvFailed"> · {{ vinvFailed }} {{ vinvRunMode === 'dry' ? 'need review' : 'failed' }}</span>
							</span>
								<button mat-stroked-button [disabled]="vinvPosting || !vinvReadyCount" (click)="vinvDryRunAll()" class="cmi-btn-outline">
									<mat-icon>fact_check</mat-icon> Preview ({{ vinvReadyCount }})
							</button>
							<button mat-raised-button [disabled]="vinvPosting || !vinvReadyCount" (click)="vinvPostAllReady()" class="cmi-btn-solid">
								<mat-icon>bolt</mat-icon> Post all ready ({{ vinvReadyCount }})
							</button>
							<button mat-button [disabled]="vinvPosting" (click)="vinvClearQueue()">Clear</button>
						</div>
					</div>

					<div class="card-body cmi-shell" [ngStyle]="themeVars">
						<!-- Vendor Intake covers two flows: vendor credits (memos) and vendor invoices. -->
						<div class="cmi-sections">
							<button type="button" [class.cmi-section--on]="section === 'credit'" (click)="setSection('credit')">
								<mat-icon>request_quote</mat-icon> Vendor Credits
							</button>
							<button type="button" [class.cmi-section--on]="section === 'invoice'" (click)="setSection('invoice')">
								<mat-icon>receipt_long</mat-icon> Vendor Invoices
							</button>
						</div>

						<ng-container *ngIf="section === 'credit'">
							<p class="cmi-sub">Drop vendor credit-memo PDFs, or import a CSV/Excel of memos. Each is read into a vendor-backed payment — matched to the customer and the open invoices it pays — for you to preview, then bulk-post or review.</p>

						<div class="cmi-modes">
							<button type="button" [class.cmi-mode--on]="importMode === 'pdf'" (click)="importMode = 'pdf'">
								<mat-icon>picture_as_pdf</mat-icon> PDF (AI read)
							</button>
							<button type="button" [class.cmi-mode--on]="importMode === 'csv'" (click)="importMode = 'csv'">
								<mat-icon>table_view</mat-icon> CSV / Excel (mapped)
							</button>
						</div>

						<div class="cmi-drop" *ngIf="importMode === 'pdf'"
							[class.cmi-drop--busy]="processing > 0"
							(dragover)="$event.preventDefault()"
							(drop)="$event.preventDefault(); onFilesDropped($event.dataTransfer?.files)">
							<input #fileInput type="file" accept="application/pdf,.pdf" multiple hidden
								(change)="onFilesDropped($event.target.files); fileInput.value=''">
							<mat-icon>cloud_upload</mat-icon>
							<div>
								<strong>Drop credit-memo PDFs here</strong>
								<span> or <button type="button" class="cmi-link" (click)="fileInput.click()">browse</button></span>
							</div>
							<div class="cmi-pref" *ngIf="rememberedMode">
								Multi-page default: <strong>{{ rememberedMode === 'split' ? 'split per page' : 'single memo' }}</strong>
								<button type="button" class="cmi-link" (click)="clearRemembered()">change</button>
							</div>
							<mat-progress-spinner *ngIf="processing > 0" mode="indeterminate" diameter="22"></mat-progress-spinner>
						</div>

						<div class="cmi-csv" *ngIf="importMode === 'csv'">
							<!-- Drop a spreadsheet; we parse it client-side and auto-map the columns. -->
							<div class="cmi-drop" *ngIf="!mappingReady" [class.cmi-drop--busy]="parsing"
								(dragover)="$event.preventDefault()"
								(drop)="$event.preventDefault(); onSpreadsheetSelected($event.dataTransfer?.files)">
								<input #csvInput type="file" accept=".csv,.xls,.xlsx,text/csv" hidden
									(change)="onSpreadsheetSelected($event.target.files); csvInput.value=''">
								<ng-container *ngIf="!parsing">
									<mat-icon>table_view</mat-icon>
									<div>
										<strong>Drop a memo CSV / Excel here</strong>
										<span> or <button type="button" class="cmi-link" (click)="csvInput.click()">browse</button></span>
									</div>
									<div class="cmi-pref">Columns auto-map; lines group by Memo No and COMMISSION lines are detected.</div>
								</ng-container>
								<ng-container *ngIf="parsing">
									<mat-progress-spinner mode="indeterminate" diameter="34"></mat-progress-spinner>
									<div>Reading spreadsheet…</div>
								</ng-container>
							</div>

							<div class="cmi-map" *ngIf="mappingReady">
								<div class="cmi-map-head">
									<div>
										<mat-icon>description</mat-icon>
										<strong>{{ csvFileName }}</strong>
										<span class="cmi-map-sub">{{ csvRows.length }} rows · {{ mappedCount() }} columns mapped</span>
									</div>
									<button type="button" class="cmi-link" (click)="resetMapping()">choose a different file</button>
								</div>

								<div class="cmi-filevendor">
									<mat-form-field class="cmi-filevendor__field" appearance="outline" color="primary">
										<mat-label>Backing vendor for this file</mat-label>
										<input type="text" matInput [(ngModel)]="fileVendorSearch"
											[matAutocomplete]="fileVendorAuto"
											(input)="searchFileVendor($any($event.target).value)"
											placeholder="Type a vendor name…" autocomplete="off">
										<mat-autocomplete #fileVendorAuto="matAutocomplete" (optionSelected)="onFileVendorPicked($event.option.value)">
											<mat-option *ngFor="let v of fileVendorResults" [value]="v">
												<strong>{{ v.suppname || v.name }}</strong> <small class="text-muted ml-2">{{ v.supplierid }}</small>
											</mat-option>
										</mat-autocomplete>
									</mat-form-field>
									<span class="cmi-filevendor__picked" *ngIf="fileVendor">
										<mat-icon>check_circle</mat-icon> {{ fileVendor.suppname }} ({{ fileVendor.supplierid }})
										<button type="button" class="cmi-link" (click)="clearFileVendor()">change</button>
									</span>
									<span class="cmi-filevendor__warn" *ngIf="!fileVendor">Optional — for single-vendor files. Leave blank when a Vendor/Manufacturer column is mapped.</span>
								</div>

								<div class="cmi-filevendor">
									<mat-form-field class="cmi-filevendor__field" appearance="outline" color="primary">
										<mat-label>Customer for this file</mat-label>
										<input type="text" matInput [(ngModel)]="fileCustomerSearch"
											[matAutocomplete]="fileCustomerAuto"
											(input)="searchFileCustomer($any($event.target).value)"
											placeholder="Type a customer name or #…" autocomplete="off">
										<mat-autocomplete #fileCustomerAuto="matAutocomplete" (optionSelected)="onFileCustomerPicked($event.option.value)">
											<mat-option *ngFor="let c of fileCustomerResults" [value]="c">
												<strong>{{ c.name }}</strong> <small class="text-muted ml-2">{{ c.debtorno }}<span *ngIf="c.branchcode">.{{ c.branchcode }}</span></small>
											</mat-option>
										</mat-autocomplete>
									</mat-form-field>
									<span class="cmi-filevendor__picked" *ngIf="fileCustomer">
										<mat-icon>check_circle</mat-icon> {{ fileCustomer.name }} ({{ fileCustomer.debtorno }})
										<button type="button" class="cmi-link" (click)="clearFileCustomer()">change</button>
									</span>
									<span class="cmi-filevendor__warn" *ngIf="!fileCustomer">These brand-portal files are per-customer — pick the customer (e.g. Vans) once and every credit loads against it. Rows that carry their own order#/dealer code still resolve individually.</span>
								</div>

								<!-- One row per target field → pick its source column. Auto-filled; adjust as needed. -->
								<div class="cmi-maprid">
									<div class="cmi-maprow" *ngFor="let col of memoMapping">
										<label>{{ col.label }} <span class="req" *ngIf="col.required">*</span></label>
										<select [(ngModel)]="columnMap[col.column]"
											[ngClass]="{ 'mapped': columnMap[col.column], 'missing': col.required && !columnMap[col.column] }">
											<option [ngValue]="''">— none —</option>
											<option *ngFor="let h of csvHeaders" [ngValue]="h">{{ h }}</option>
										</select>
									</div>
								</div>

								<div class="cmi-map-actions">
									<button mat-raised-button color="accent" [disabled]="!mappingValid()" (click)="importMapped()">
										<mat-icon>playlist_add_check</mat-icon> Import &amp; match memos
									</button>
									<span class="cmi-map-hint" *ngIf="!mappingValid()">Map Memo No, Customer Account and Credit Total to continue.</span>
								</div>
							</div>
						</div>

						<div class="cmi-matching" *ngIf="matching">
							<div class="cmi-matching-row">
								<mat-progress-spinner mode="indeterminate" diameter="22"></mat-progress-spinner>
								<span>Matching memos to customers &amp; invoices… <strong>{{ matchedCount }} / {{ matchTotal }}</strong></span>
							</div>
							<mat-progress-bar mode="determinate" [value]="matchTotal ? (matchedCount / matchTotal) * 100 : 0"></mat-progress-bar>
						</div>

						<!-- One step per page; lights up as each per-page AI call returns. -->
						<div class="vinv-steppers" *ngIf="cmJobs.length">
							<div class="vinv-stepper" *ngFor="let job of cmJobs">
								<div class="vinv-stepper-head">
									<mat-icon>auto_awesome</mat-icon>
									<span>Reading <strong>{{ job.fileName }}</strong> — page {{ job.current }} of {{ job.total }}</span>
									<span class="vinv-stepper-count">{{ job.done }} read<span *ngIf="job.failed"> · {{ job.failed }} failed</span></span>
									<button mat-icon-button *ngIf="job.failed && job.current >= job.total" (click)="dismissCmJob(job)" matTooltip="Dismiss"><mat-icon>close</mat-icon></button>
								</div>
								<div class="vinv-stepper-err" *ngIf="job.lastError"><mat-icon>error</mat-icon> {{ job.lastError }}</div>
								<div class="vinv-steps">
									<div class="vinv-step" *ngFor="let n of cmStepArray(job)" [ngClass]="'vinv-step--' + cmStepState(job, n)">
										<span class="vinv-step-dot">
											<mat-icon *ngIf="cmStepState(job,n)==='done'">check</mat-icon>
											<mat-progress-spinner *ngIf="cmStepState(job,n)==='active'" mode="indeterminate" diameter="16"></mat-progress-spinner>
											<ng-container *ngIf="cmStepState(job,n)==='pending'">{{ n }}</ng-container>
										</span>
									</div>
								</div>
							</div>
						</div>

						<div class="cmi-queue vinv-workbench" *ngIf="queue.length; else empty">
							<mat-progress-bar *ngIf="posting" mode="determinate" [value]="postTotal ? ((postedCount + failedCount) / postTotal) * 100 : 0"></mat-progress-bar>

							<div class="cmi-stats">
								<div class="cmi-stat cmi-stat--exception" [class.cmi-stat--on]="cmExceptionRows.length">
									<span class="cmi-stat-val">{{ cmExceptionRows.length }}</span>
									<span class="cmi-stat-lbl">Need attention</span>
								</div>
								<div class="cmi-stat cmi-stat--ready" [class.cmi-stat--on]="cmReadyRows.length">
									<span class="cmi-stat-val">{{ cmReadyRows.length }}</span>
									<span class="cmi-stat-lbl">Ready to post</span>
								</div>
								<div class="cmi-stat">
									<span class="cmi-stat-val">{{ cmPostedRows.length }}</span>
									<span class="cmi-stat-lbl">Posted</span>
								</div>
								<div class="cmi-stat" [class.cmi-stat--warn]="!cmReconcileBatch()">
									<span class="cmi-stat-val">{{ cmEnteredTotal | currency }}</span>
									<span class="cmi-stat-lbl">Batch total ({{ queue.length }})</span>
								</div>
							</div>

							<!-- Batch journal -->
							<div class="vinv-journal">
								<div class="vinv-journal__head">
									<mat-icon>receipt_long</mat-icon> Batch journal
									<span class="vinv-journal__chips">
										<span class="vinv-flag vinv-flag--dup" *ngIf="cmDupCount">{{ cmDupCount }} already entered</span>
										<span class="vinv-flag vinv-flag--warn" *ngIf="cmMismatchCount">{{ cmMismatchCount }} not fully applied</span>
										<span class="vinv-flag vinv-flag--dup" *ngIf="cmBatchDupCount">{{ cmBatchDupCount }} double scan</span>
									</span>
									<span class="vinv-journal__export">
										<button type="button" class="cmi-link" (click)="exportCmJournalPdf()" matTooltip="Export batch journal as PDF"><mat-icon>picture_as_pdf</mat-icon> PDF</button>
										<button type="button" class="cmi-link" (click)="exportCmJournalXlsx()" matTooltip="Export batch journal as Excel"><mat-icon>table_view</mat-icon> XLSX</button>
									</span>
								</div>
								<div class="vinv-journal__scroll">
									<table class="vinv-table vinv-journal__table">
										<thead>
											<tr><th>#</th><th>Memo</th><th>Vendor</th><th>Customer</th><th>Source</th><th class="num">Credit $</th><th class="num">Applied $</th><th>Status</th><th></th></tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of queue; let i = index">
												<td>{{ i + 1 }}</td>
												<td>{{ item.memo.fields.credit_memo_number || '—' }}</td>
												<td><small>{{ item.memo.vendor_match?.suppname || item.memo.fields.vendor_name || '—' }}</small></td>
												<td><small>{{ item.memo.customer_match?.name || item.memo.fields.customer_name || '—' }}</small></td>
												<td><small>{{ item.fileName }}<span *ngIf="cmPageLabel(item)"> · {{ cmPageLabel(item) }}</span></small></td>
												<td class="num">{{ item.memo.ar_receipt | currency }}</td>
												<td class="num" [ngClass]="cmReconciles(item) ? '' : 'vinv-warn'">{{ allocatedTotal(item) | currency }}</td>
												<td class="vinv-journal__flags">
													<span class="vinv-flag" [ngClass]="isReady(item) || item.status === 'posted' ? 'vinv-flag--ok' : (item.duplicate || cmInBatchDup(item) ? 'vinv-flag--dup' : (item.status === 'failed' || item.status === 'skipped' ? 'vinv-flag--fail' : 'vinv-flag--warn'))">{{ cmReviewReason(item) }}</span>
													<span class="vinv-journal__detail" *ngIf="cmDetail(item) && item.status !== 'posted'" [matTooltip]="cmDetail(item)">{{ cmDetail(item) }}</span>
												</td>
												<td class="vinv-journal__action">
													<button type="button" class="cmi-link" (click)="item.expanded = !cmShowBody(item)">{{ cmShowBody(item) ? 'Close' : 'Review' }}</button>
												</td>
											</tr>
										</tbody>
										<tfoot>
											<tr class="vinv-journal__total">
												<td colspan="5">Grand total — match your physical stack</td>
												<td class="num">{{ cmInvoiceTotal | currency }}</td>
												<td class="num" [ngClass]="cmReconcileBatch() ? '' : 'vinv-warn'">{{ cmEnteredTotal | currency }}</td>
												<td colspan="2"></td>
											</tr>
										</tfoot>
									</table>
								</div>
							</div>

							<!-- Triage cards (exceptions surface, ready collapses, posted fades) -->
							<div class="vinv-card" *ngFor="let item of cmSortedRows" [ngClass]="{
									'vinv-card--exception': cmState(item) === 'exception',
									'vinv-card--ready': cmState(item) === 'ready',
									'vinv-card--posted': cmState(item) === 'posted',
									'vinv-card--dryfail': item.dry === 'fail'
								}">
								<header class="vinv-head">
									<div class="vinv-head__row" (click)="item.expanded = !cmShowBody(item)">
										<div class="vinv-head__id">
											<span class="vinv-head__chev"><mat-icon>{{ cmShowBody(item) ? 'expand_more' : 'chevron_right' }}</mat-icon></span>
											<mat-icon class="vinv-head__icon">request_quote</mat-icon>
											<div class="vinv-head__idtext">
												<strong>{{ item.memo.fields.credit_memo_number || 'no memo #' }}</strong>
												<small>{{ item.fileName }}<span *ngIf="cmPageLabel(item)"> · {{ cmPageLabel(item) }}</span></small>
											</div>
										</div>
										<div class="vinv-head__vendor" (click)="$event.stopPropagation()">
											<span class="vinv-chip vinv-chip--vendor"><mat-icon>storefront</mat-icon>{{ item.memo.vendor_match?.suppname || item.memo.fields.vendor_name || 'unmatched vendor' }}</span>
											<span class="vinv-chip" *ngIf="item.memo.customer_match"><mat-icon>person</mat-icon>{{ item.memo.customer_match.name }}</span>
										</div>
										<div class="vinv-head__amts">
											<span class="vinv-amt"><small>Credit</small><b>{{ item.memo.ar_receipt | currency }}</b></span>
											<span class="vinv-amt" [ngClass]="cmReconciles(item) ? 'vinv-amt--ok' : 'vinv-amt--warn'">
												<small>Applied</small><b>{{ allocatedTotal(item) | currency }}</b>
												<mat-icon>{{ cmReconciles(item) ? 'check_circle' : 'error_outline' }}</mat-icon>
											</span>
										</div>
									</div>
									<div class="vinv-head__sub" (click)="item.expanded = !cmShowBody(item)">
										<mat-icon>account_balance_wallet</mat-icon>
										<span>{{ cmSelSummary(item) }}</span>
									</div>
									<div class="vinv-head__toolbar" (click)="$event.stopPropagation()">
										<span class="vinv-pill" [ngClass]="cmIssueIsDup(iss) ? 'vinv-pill--dup' : 'vinv-pill--warn'" *ngFor="let iss of cmIssues(item)">{{ iss }}</span>
										<span class="vinv-pill vinv-pill--ready" *ngIf="cmState(item) === 'ready'"><mat-icon>check_circle</mat-icon> Ready</span>
										<span class="vinv-pill vinv-pill--posted" *ngIf="item.status === 'posted'"><mat-icon>check_circle</mat-icon> Posted {{ item.message }}</span>
										<span class="vinv-pill vinv-pill--fail" *ngIf="item.status === 'failed' || item.status === 'skipped'" [matTooltip]="item.message"><mat-icon>error_outline</mat-icon> {{ item.message || 'Post failed' }}</span>
										<span class="vinv-pill vinv-pill--fail" *ngIf="item.status !== 'failed' && item.status !== 'skipped' && item.dry === 'fail'" [matTooltip]="item.dryMessage"><mat-icon>report_problem</mat-icon> {{ item.dryMessage || 'Preview failed' }}</span>
										<button mat-stroked-button class="vinv-btn cmi-btn-outline" [disabled]="!isReady(item) || item.status === 'posting'" (click)="cmDryRun(item)"><mat-icon>fact_check</mat-icon> Preview</button>
										<button mat-flat-button class="vinv-btn cmi-btn-solid" [disabled]="!isReady(item) || item.status === 'posting' || item.status === 'posted'" (click)="cmPost(item)">
											<mat-icon>{{ item.status === 'failed' ? 'replay' : 'bolt' }}</mat-icon> {{ item.status === 'failed' ? 'Retry post' : 'Post' }}
										</button>
										<button mat-icon-button class="cmi-icon-btn" *ngIf="cmHasSource(item)" (click)="cmViewSource(item)" matTooltip="View the source page sent to the AI"><mat-icon>picture_as_pdf</mat-icon></button>
										<button mat-icon-button class="cmi-icon-btn" [disabled]="posting" (click)="remove(item)" matTooltip="Remove"><mat-icon>close</mat-icon></button>
									</div>
								</header>

								<div class="vinv-body" *ngIf="cmShowBody(item)">
									<!-- Vendor — auto-matched, but always changeable (two near-identical US Autoforce suppliers tie) -->
									<section class="vinv-section">
										<div class="vinv-section__title">
											<mat-icon>storefront</mat-icon> Vendor
											<button type="button" class="cmi-link vinv-section__action" (click)="item.venOpen = !item.venOpen">{{ item.venOpen ? 'Cancel' : 'Change' }}</button>
										</div>
										<div class="vinv-vendor-current">
											<span class="vinv-chip vinv-chip--vendor"><mat-icon>storefront</mat-icon>{{ item.memo.vendor_match?.suppname || item.memo.fields.vendor_name || 'unmatched' }}</span>
											<small class="vinv-muted" *ngIf="item.memo.vendor_match">{{ item.memo.vendor_match.supplierid }}<span *ngIf="!item.memo.vendor_match.auto"> · low confidence — confirm</span></small>
											<small class="vinv-muted" *ngIf="item.memo.fields.vendor_name"> · read as “{{ item.memo.fields.vendor_name }}”</small>
										</div>
										<div class="cmi-custpick" *ngIf="item.venOpen || !item.memo.vendor_match?.auto">
											<input type="text" class="cmi-custsearch" [(ngModel)]="item.venSearch" (input)="cmSearchVendor(item, item.venSearch)" placeholder="Search vendor name or supplier #…" autocomplete="off">
											<div class="cmi-custresults" *ngIf="item.venResults?.length">
												<button type="button" class="cmi-custopt" *ngFor="let v of item.venResults" (click)="cmPickVendor(item, v)">
													<strong>{{ v.suppname || v.name }}</strong> <small>{{ v.supplierid }}</small>
												</button>
											</div>
										</div>
									</section>

									<!-- Credit details -->
									<section class="vinv-section">
										<div class="vinv-section__title"><mat-icon>description</mat-icon> Credit details</div>
										<div class="vinv-fields">
											<div><label>Memo #</label><span class="vinv-ro">{{ item.memo.fields.credit_memo_number || '—' }}</span></div>
											<div *ngIf="item.memo.fields.program_dealer"><label>For dealer</label><span class="vinv-ro vinv-ro--strong">{{ item.memo.fields.program_dealer }}</span></div>
											<div><label>Source invoice</label><span class="vinv-ro">{{ item.memo.fields.source_invoice_ref || item.memo.fields.po_number || '—' }}</span></div>
											<div><label>Date</label><span class="vinv-ro">{{ item.memo.fields.invoice_date || '—' }}</span></div>
											<div><label>Total</label><span class="vinv-ro">{{ item.memo.fields.total_amount | currency }}</span></div>
											<div><label>Commission</label><span class="vinv-ro">{{ item.memo.fields.commission_amount | currency }}</span></div>
											<div><label>Credit (AR)</label><span class="vinv-ro vinv-ro--strong">{{ item.memo.ar_receipt | currency }}</span></div>
											<div *ngIf="item.memo.fields.vendor_remit_to" class="vinv-fields--wide"><label>Remit to</label><span class="vinv-ro">{{ item.memo.fields.vendor_remit_to }}</span></div>
										</div>
									</section>

									<!-- Apply credit: customer match + open-invoice allocation -->
									<section class="vinv-section">
										<div class="vinv-section__title"><mat-icon>account_balance_wallet</mat-icon> Apply credit</div>
										<div class="cmi-custpick" *ngIf="!item.memo.customer_match?.auto">
											<!-- A non-auto match is a SUGGESTION (resolved from the Notes dealer) → confirm or change. -->
											<div class="cmi-custpick-head" *ngIf="item.memo.customer_match">
												<mat-icon>person_search</mat-icon>
												Suggested: <strong>{{ item.memo.customer_match.name }}</strong> ({{ item.memo.customer_match.debtorno }})
												<span class="vinv-muted" *ngIf="$any(item.memo.customer_match).via"> · {{ $any(item.memo.customer_match).via }}</span>
												<button type="button" class="cmi-link" [disabled]="item.resolving" (click)="pickRowCustomer(item, item.memo.customer_match)">Confirm</button>
											</div>
											<div class="cmi-custpick-head" *ngIf="!item.memo.customer_match">
												<mat-icon>person_search</mat-icon>
												Couldn't match <strong>{{ item.memo.fields.customer_name || 'this memo' }}</strong>
												<span *ngIf="item.memo.fields.po_number || item.memo.fields.source_invoice_ref"> (ref {{ item.memo.fields.po_number || item.memo.fields.source_invoice_ref }})</span> — pick the customer.
											</div>
											<input type="text" class="cmi-custsearch" [(ngModel)]="item.custSearch" (input)="searchRowCustomer(item, item.custSearch)" [placeholder]="item.memo.customer_match ? 'Wrong dealer? search to change…' : 'Search customer name or #…'" [disabled]="item.resolving">
											<div class="cmi-custresults" *ngIf="item.custResults.length">
												<button type="button" class="cmi-custopt" *ngFor="let c of item.custResults" [disabled]="item.resolving" (click)="pickRowCustomer(item, c)">
													<strong>{{ c.name }}</strong> <small>{{ c.debtorno }}<span *ngIf="c.branchcode">.{{ c.branchcode }}</span></small>
												</button>
											</div>
											<div class="cmi-custhint" *ngIf="item.resolving">Loading invoices…</div>
										</div>
										<div class="cmi-invpick" *ngIf="item.memo.customer_match?.auto">
											<div class="cmi-invpick-customer">
												<mat-icon>person</mat-icon> Applying to <strong>{{ item.memo.customer_match.name }}</strong> ({{ item.memo.customer_match.debtorno }})
												<button type="button" class="cmi-link" [disabled]="item.resolving" (click)="item.custChange = !item.custChange">{{ item.custChange ? 'Cancel' : 'Change' }}</button>
											</div>
											<div class="cmi-custpick" *ngIf="item.custChange">
												<input type="text" class="cmi-custsearch" [(ngModel)]="item.custSearch" (input)="searchRowCustomer(item, item.custSearch)" placeholder="Search a different customer…" [disabled]="item.resolving">
												<div class="cmi-custresults" *ngIf="item.custResults.length">
													<button type="button" class="cmi-custopt" *ngFor="let c of item.custResults" [disabled]="item.resolving" (click)="pickRowCustomer(item, c); item.custChange = false">
														<strong>{{ c.name }}</strong> <small>{{ c.debtorno }}<span *ngIf="c.branchcode">.{{ c.branchcode }}</span></small>
													</button>
												</div>
											</div>
											<div class="cmi-invpick-head">
												Select invoices and set how much of this {{ item.memo.ar_receipt | currency }} credit to apply — partial is fine, the invoice stays open for the rest.
												<span class="cmi-invpick-bal" [ngClass]="cmApplied(item) ? 'ok' : 'warn'">receipt posts {{ allocatedTotal(item) | currency }}<span class="vinv-muted" *ngIf="!fullyApplied(item) && cmApplied(item)"> · partial of {{ item.memo.ar_receipt | currency }}</span></span>
											</div>
											<div class="cmi-invpick-empty" *ngIf="!customerInvoices(item).length">No open invoices for this customer.</div>
											<table class="cmi-invtable" *ngIf="customerInvoices(item).length">
												<tr class="cmi-invtable__head">
													<td class="chk"></td><td>Invoice</td><td>Order</td><td>Ref</td><td>Date</td><td class="num">Balance</td><td class="num">Apply $</td>
												</tr>
												<tr *ngFor="let inv of customerInvoices(item)" [class.sel]="isSelected(item, inv)">
													<td class="chk"><mat-checkbox [checked]="isSelected(item, inv)" [disabled]="posting" (change)="toggleInvoice(item, inv)"></mat-checkbox></td>
													<td>#{{ inv.transno }}</td>
													<td><small>{{ inv.orderno }}</small></td>
													<td><small>{{ inv.reference }}</small></td>
													<td><small>{{ inv.trandate }}</small></td>
													<td class="num">{{ inv.leftto | currency }}</td>
													<td class="num">
														<input *ngIf="isSelected(item, inv)" class="cmi-alloc" [class.cmi-alloc--partial]="cmAllocationFor(item, inv) < inv.leftto - 0.005"
															type="number" step="0.01" min="0" [max]="inv.leftto"
															[value]="cmAllocationFor(item, inv)" [disabled]="posting"
															(change)="cmSetAllocation(item, inv, $any($event.target).value)"
															[matTooltip]="cmAllocationFor(item, inv) < inv.leftto - 0.005 ? 'Partial — invoice stays open at ' + ((inv.leftto - cmAllocationFor(item, inv)) | currency) : ''">
														<span *ngIf="!isSelected(item, inv)" class="vinv-muted">—</span>
													</td>
												</tr>
											</table>
										</div>
									</section>

									<!-- Raw AI extraction + match diagnostics -->
									<div class="vinv-rawbar">
										<button type="button" class="cmi-link" (click)="item.showRaw = !item.showRaw">{{ item.showRaw ? 'Hide raw AI' : 'Show raw AI' }}</button>
									</div>
									<pre class="vinv-raw" *ngIf="item.showRaw">{{ cmRaw(item) }}</pre>
								</div>
							</div>
						</div>

						<ng-template #empty>
							<div class="cmi-empty" *ngIf="processing === 0">No memos yet — add files above.</div>
						</ng-template>
						</ng-container>

						<!-- ───────────────────────── VENDOR INVOICES ───────────────────────── -->
						<ng-container *ngIf="section === 'invoice'">
						<p class="cmi-sub">Drop invoices, check the batch journal, match GRNs, preview, then post.</p>

						<div class="cmi-drop" [class.cmi-drop--busy]="vinvProcessing > 0"
							(dragover)="$event.preventDefault()"
							(drop)="$event.preventDefault(); onVendorPdfsDropped($event.dataTransfer?.files)">
							<input #vinvInput type="file" accept="application/pdf,.pdf" multiple hidden
								(change)="onVendorPdfsDropped($event.target.files); vinvInput.value=''">
							<mat-icon>cloud_upload</mat-icon>
							<div>
								<strong>Drop vendor invoice PDFs here</strong>
								<span> or <button type="button" class="cmi-link" (click)="vinvInput.click()">browse</button></span>
							</div>
							<mat-progress-spinner *ngIf="vinvProcessing > 0" mode="indeterminate" diameter="22"></mat-progress-spinner>
						</div>

						<!-- One step per page; lights up as each per-page AI call returns. -->
						<div class="vinv-steppers" *ngIf="vinvJobs.length">
							<div class="vinv-stepper" *ngFor="let job of vinvJobs" [class.vinv-stepper--paused]="!job.running && vinvJobHasOpen(job)">
								<div class="vinv-stepper-head">
									<mat-icon>{{ job.running ? 'auto_awesome' : (vinvJobHasOpen(job) ? 'pause_circle' : 'check_circle') }}</mat-icon>
									<span *ngIf="job.running">Reading <strong>{{ job.fileName }}</strong> — page {{ job.current }} of {{ job.total }}</span>
									<span *ngIf="!job.running"><strong>{{ job.fileName }}</strong> — {{ job.done }} of {{ job.total }} read<span *ngIf="vinvJobHasOpen(job)">, {{ job.total - job.done }} still to read</span></span>
									<span class="vinv-stepper-count">{{ job.done }} read<span *ngIf="job.failed"> · {{ job.failed }} failed</span></span>
									<button mat-stroked-button color="primary" class="vinv-resend-btn"
										*ngIf="!job.running && vinvJobHasOpen(job)" (click)="resendVinvJob(job)"
										matTooltip="Re-read the unread/failed pages">
										<mat-icon>refresh</mat-icon> Resend
									</button>
									<button mat-icon-button *ngIf="!job.running" (click)="dismissVinvJob(job)" matTooltip="Dismiss"><mat-icon>close</mat-icon></button>
								</div>
								<div class="vinv-stepper-err" *ngIf="job.lastError">
									<mat-icon>error</mat-icon> {{ job.lastError }}
								</div>
								<div class="vinv-steps">
									<div class="vinv-step" *ngFor="let n of vinvStepArray(job)" [ngClass]="'vinv-step--' + vinvStepState(job, n)">
										<span class="vinv-step-dot">
											<mat-icon *ngIf="vinvStepState(job,n)==='done'">check</mat-icon>
											<mat-progress-spinner *ngIf="vinvStepState(job,n)==='active'" mode="indeterminate" diameter="16"></mat-progress-spinner>
											<mat-icon *ngIf="vinvStepState(job,n)==='failed'">priority_high</mat-icon>
											<ng-container *ngIf="vinvStepState(job,n)==='pending'">{{ n }}</ng-container>
										</span>
									</div>
								</div>
							</div>
						</div>

							<div class="cmi-queue vinv-workbench" *ngIf="vinvQueue.length; else vinvEmpty">
								<mat-progress-bar *ngIf="vinvPosting" mode="determinate"
									[value]="vinvTotal ? ((vinvPosted + vinvFailed) / vinvTotal) * 100 : 0"></mat-progress-bar>

								<div class="cmi-stats">
									<div class="cmi-stat cmi-stat--exception" [class.cmi-stat--on]="vinvExceptionRows.length"
										[class.cmi-stat--jump]="vinvExceptionRows.length"
										(click)="jumpToNextIssue()"
										[matTooltip]="vinvExceptionRows.length ? 'Jump to next issue' : ''">
										<span class="cmi-stat-val">{{ vinvExceptionRows.length }}</span>
										<span class="cmi-stat-lbl">Need attention <mat-icon *ngIf="vinvExceptionRows.length" class="cmi-stat-jumpicon">my_location</mat-icon></span>
									</div>
									<div class="cmi-stat cmi-stat--ready" [class.cmi-stat--on]="vinvReadyRows.length">
										<span class="cmi-stat-val">{{ vinvReadyRows.length }}</span>
										<span class="cmi-stat-lbl">Ready to post</span>
									</div>
									<div class="cmi-stat">
										<span class="cmi-stat-val">{{ vinvPostedRows.length }}</span>
										<span class="cmi-stat-lbl">Posted</span>
									</div>
									<div class="cmi-stat" [class.cmi-stat--warn]="!vinvReconcileBatch()">
										<span class="cmi-stat-val">{{ vinvEnteredTotal | currency }}</span>
										<span class="cmi-stat-lbl">Batch total ({{ vinvQueue.length }})</span>
									</div>
								</div>
							<!-- Batch journal first — reconcile the stack before drilling into cards. -->
							<div class="vinv-journal">
								<div class="vinv-journal__head">
									<mat-icon>receipt_long</mat-icon> Batch journal
									<span class="vinv-journal__chips">
										<span class="vinv-flag vinv-flag--dup" *ngIf="vinvDupCount">{{ vinvDupCount }} already entered</span>
										<span class="vinv-flag vinv-flag--warn" *ngIf="vinvMismatchCount">{{ vinvMismatchCount }} totals differ</span>
										<span class="vinv-flag vinv-flag--dup" *ngIf="vinvBatchDupCount">{{ vinvBatchDupCount }} double scan</span>
									</span>
									<span class="vinv-journal__export">
										<button type="button" class="cmi-link" (click)="exportVinvJournalPdf()" matTooltip="Export batch journal as PDF">
											<mat-icon>picture_as_pdf</mat-icon> PDF
										</button>
										<button type="button" class="cmi-link" (click)="exportVinvJournalXlsx()" matTooltip="Export batch journal as Excel">
											<mat-icon>table_view</mat-icon> XLSX
										</button>
									</span>
								</div>
								<div class="vinv-journal__scroll">
									<table class="vinv-table vinv-journal__table">
										<thead>
												<tr><th></th><th>#</th><th>Invoice</th><th>Vendor</th><th>Source</th><th class="num">Invoice $</th><th class="num">Entered $</th><th>Status</th><th></th></tr>
											</thead>
											<tbody>
												<tr *ngFor="let item of vinvQueue; let i = index">
													<td class="vinv-send__cell">
														<button type="button" class="vinv-send" [ngClass]="'vinv-send--' + vinvSendState(item)"
															[disabled]="!vinvHasSource(item)" (click)="vinvViewSource(item)" [matTooltip]="vinvSendTitle(item)">
															<mat-icon>{{ vinvSendIcon(item) }}</mat-icon>
														</button>
													</td>
													<td>{{ i + 1 }}</td>
													<td>{{ item.fields.invoice_number || '—' }}</td>
													<td><small>{{ item.vendor?.suppname || item.vendor_match?.suppname || '—' }}</small></td>
													<td><small><button type="button" class="cmi-link" *ngIf="vinvHasSource(item)" (click)="vinvViewSource(item)" matTooltip="View the scanned page">{{ item.fileName }}<span *ngIf="item.page"> · p{{ item.page }}</span></button><span *ngIf="!vinvHasSource(item)">{{ item.fileName }}<span *ngIf="item.page"> · p{{ item.page }}</span></span></small></td>
													<td class="num">{{ item.fields.total_amount | currency }}</td>
													<td class="num" [ngClass]="(item.duplicate || vinvReconciles(item)) ? '' : 'vinv-warn'">{{ vinvEnteredDisplay(item) | currency }}</td>
													<td class="vinv-journal__flags">
														<span class="vinv-flag" [ngClass]="vinvReady(item) || item.status === 'posted' ? 'vinv-flag--ok' : (item.duplicate || vinvInBatchDup(item) ? 'vinv-flag--dup' : (item.status === 'failed' ? 'vinv-flag--fail' : 'vinv-flag--warn'))">{{ vinvReviewReason(item) }}</span>
														<span class="vinv-flag vinv-flag--warn" *ngIf="item.unmatched.length && item.status !== 'posted'">{{ item.unmatched.length }} unmatched</span>
														<span class="vinv-journal__detail" *ngIf="vinvDetail(item) && item.status !== 'posted'" [matTooltip]="vinvDetail(item)">{{ vinvDetail(item) }}</span>
													</td>
													<td class="vinv-journal__action">
														<button type="button" class="cmi-link cmi-link--fix" *ngIf="vinvState(item) === 'exception'" (click)="item.expanded = !vinvShowBody(item)">{{ vinvShowBody(item) ? 'Close' : 'Fix' }}</button>
													</td>
												</tr>
											</tbody>
										<tfoot>
											<tr class="vinv-journal__total">
												<td colspan="5">Grand total — match your physical stack</td>
												<td class="num">{{ vinvInvoiceTotal | currency }}</td>
												<td class="num" [ngClass]="vinvReconcileBatch() ? '' : 'vinv-warn'">{{ vinvEnteredTotal | currency }}</td>
													<td colspan="2"></td>
												</tr>
											</tfoot>
										</table>
								</div>
							</div>

							<div class="vinv-card" *ngFor="let item of vinvSortedRows; trackBy: vinvTrackById" [id]="'vinv-card-' + item.id" [ngClass]="{
									'vinv-card--exception': vinvState(item) === 'exception',
									'vinv-card--ready': vinvState(item) === 'ready',
									'vinv-card--posted': vinvState(item) === 'posted',
									'vinv-card--dryfail': item.dry === 'fail'
								}">
								<header class="vinv-head">
									<div class="vinv-head__row" (click)="item.expanded = !vinvShowBody(item)">
											<div class="vinv-head__id">
												<span class="vinv-head__chev"><mat-icon>{{ vinvShowBody(item) ? 'expand_more' : 'chevron_right' }}</mat-icon></span>
												<mat-icon class="vinv-head__icon">receipt_long</mat-icon>
												<div class="vinv-head__idtext">
													<strong>{{ item.fields.invoice_number || 'no invoice #' }}</strong>
													<small>{{ item.fileName }}<span *ngIf="item.pages?.length"> · p{{ item.pages.join(', ') }}</span><span *ngIf="!item.pages?.length && item.page"> · p{{ item.page }}</span></small>
												</div>
											</div>

										<div class="vinv-head__vendor" (click)="$event.stopPropagation()">
											<ng-container *ngIf="item.vendor_match?.auto || item.vendor">
												<span class="vinv-chip vinv-chip--vendor"><mat-icon>storefront</mat-icon>{{ item.vendor?.suppname || item.vendor_match?.suppname }}</span>
												<small class="vinv-muted" *ngIf="item.loadingVendor">loading GRNs…</small>
											</ng-container>
											<ng-container *ngIf="!item.vendor_match?.auto && !item.vendor">
												<mat-form-field appearance="outline" class="vinv-vendor-pick" subscriptSizing="dynamic">
													<mat-label>Match vendor</mat-label>
													<input matInput [matAutocomplete]="vendorAuto"
														(input)="searchRowVendor($any($event.target).value)" placeholder="vendor name…" autocomplete="off">
													<mat-autocomplete #vendorAuto="matAutocomplete" (optionSelected)="confirmVendor(item, $event.option.value)">
														<mat-option *ngFor="let v of vinvVendorResults" [value]="v">
															<strong>{{ v.suppname || v.name }}</strong> <small class="text-muted ml-2">{{ v.supplierid }}</small>
														</mat-option>
													</mat-autocomplete>
												</mat-form-field>
												<small class="vinv-vendor-hint" *ngIf="item.fields.vendor_name">read as "{{ item.fields.vendor_name }}"</small>
											</ng-container>
										</div>

											<div class="vinv-head__amts">
												<span class="vinv-amt"><small>Invoice</small><b>{{ item.fields.total_amount | currency }}</b></span>
												<span class="vinv-amt" [ngClass]="(item.duplicate || vinvReconciles(item)) ? 'vinv-amt--ok' : 'vinv-amt--warn'">
													<small>{{ item.duplicate ? 'Posted' : 'Entered' }}</small><b>{{ vinvEnteredDisplay(item) | currency }}</b>
													<mat-icon>{{ (item.duplicate || vinvReconciles(item)) ? 'check_circle' : 'error_outline' }}</mat-icon>
												</span>
											</div>
										</div>

										<div class="vinv-head__sub" (click)="item.expanded = !vinvShowBody(item)">
											<mat-icon>inventory</mat-icon>
											<span>{{ vinvSelSummary(item) }}</span>
										</div>

										<div class="vinv-head__toolbar" (click)="$event.stopPropagation()">
											<span class="vinv-pill" [ngClass]="vinvIssueIsDup(iss) ? 'vinv-pill--dup' : 'vinv-pill--warn'" *ngFor="let iss of vinvIssues(item)">{{ iss }}</span>
											<span class="vinv-pill vinv-pill--ready" *ngIf="vinvState(item) === 'ready'"><mat-icon>check_circle</mat-icon> Ready</span>
											<span class="vinv-pill vinv-pill--posted" *ngIf="item.status === 'posted'"><mat-icon>check_circle</mat-icon> Posted {{ item.message }}</span>
											<span class="vinv-pill vinv-pill--fail" *ngIf="item.status === 'failed'" [matTooltip]="item.message"><mat-icon>error_outline</mat-icon> {{ item.message || 'Post failed' }}</span>
											<span class="vinv-pill vinv-pill--fail" *ngIf="item.status !== 'failed' && item.dry === 'fail'" [matTooltip]="item.dryMessage"><mat-icon>report_problem</mat-icon> {{ item.dryMessage || 'Preview failed' }}</span>
											<button mat-stroked-button class="vinv-btn cmi-btn-outline" [disabled]="!item.vendor || !item.grns.length || item.status === 'posting'" (click)="vinvDryRun(item)">
												<mat-icon>fact_check</mat-icon> Preview
											</button>
										<button mat-flat-button class="vinv-btn cmi-btn-solid" [disabled]="!vinvReady(item) || item.status === 'posting' || item.status === 'posted'" (click)="vinvPost(item)">
											<mat-icon>{{ item.status === 'failed' ? 'replay' : 'bolt' }}</mat-icon> {{ item.status === 'failed' ? 'Retry post' : 'Post' }}
										</button>
										<button mat-icon-button class="cmi-icon-btn" *ngIf="vinvHasSource(item)" (click)="vinvViewSource(item)" matTooltip="View the source page sent to the AI">
											<mat-icon>picture_as_pdf</mat-icon>
										</button>
										<button mat-icon-button class="cmi-icon-btn" [disabled]="item.status === 'posting'" (click)="vinvRemove(item)" matTooltip="Remove">
											<mat-icon>close</mat-icon>
										</button>
									</div>
								</header>

								<div class="vinv-body" *ngIf="vinvShowBody(item)">
									<!-- Vendor — auto-matched, but always changeable (re-loads that vendor's open GRNs) -->
									<section class="vinv-section">
										<div class="vinv-section__title">
											<mat-icon>storefront</mat-icon> Vendor
											<button type="button" class="cmi-link vinv-section__action" (click)="item.venOpen = !item.venOpen">{{ item.venOpen ? 'Cancel' : 'Change' }}</button>
										</div>
										<div class="vinv-vendor-current">
											<span class="vinv-chip vinv-chip--vendor"><mat-icon>storefront</mat-icon>{{ item.vendor?.suppname || item.vendor_match?.suppname || item.fields.vendor_name || 'unmatched' }}</span>
											<small class="vinv-muted" *ngIf="item.vendor_match">{{ item.vendor_match.supplierid }}<span *ngIf="!item.vendor_match.auto"> · low confidence — confirm</span></small>
											<small class="vinv-muted" *ngIf="item.loadingVendor"> · loading GRNs…</small>
											<small class="vinv-muted" *ngIf="item.fields.vendor_name"> · read as “{{ item.fields.vendor_name }}”</small>
										</div>
										<div class="cmi-custpick" *ngIf="item.venOpen">
											<input type="text" class="cmi-custsearch" [(ngModel)]="item.venSearch" (input)="searchRowVendor(item.venSearch)" placeholder="Search vendor name or supplier #…" autocomplete="off">
											<div class="cmi-custresults" *ngIf="vinvVendorResults.length">
												<button type="button" class="cmi-custopt" *ngFor="let v of vinvVendorResults" (click)="confirmVendor(item, v); item.venOpen = false; item.venSearch = ''">
													<strong>{{ v.suppname || v.name }}</strong> <small>{{ v.supplierid }}</small>
												</button>
											</div>
										</div>
									</section>

									<!-- Invoice details — editable in-screen before posting -->
									<section class="vinv-section">
										<div class="vinv-section__title"><mat-icon>description</mat-icon> Invoice details</div>
										<div class="vinv-fields">
											<div><label>Invoice #</label><input type="text" [(ngModel)]="item.fields.invoice_number" (change)="onInvoiceNoEdited(item)"></div>
											<div><label>Invoice date</label><input type="date" [(ngModel)]="item.fields.invoice_date" (change)="persist()"></div>
											<div><label>Due date</label><input type="date" [(ngModel)]="item.fields.due_date" (change)="persist()"></div>
											<div><label>Discount date</label><input type="date" [(ngModel)]="item.fields.discount_date" (change)="persist()"></div>
											<div><label>Discount $</label><input type="number" step="0.01" [(ngModel)]="item.fields.discount_amount" (change)="persist()"></div>
											<div><label>PO / SO #</label><span class="vinv-ro">{{ item.fields.po_numbers?.length ? item.fields.po_numbers.join(', ') : '—' }}</span></div>
											<div><label>Subtotal</label><span class="vinv-ro">{{ item.fields.subtotal | currency }}</span></div>
											<div><label>Tax</label><span class="vinv-ro">{{ item.fields.tax_amount | currency }}</span></div>
											<div *ngIf="item.fields.freight_amount"><label>Freight</label><span class="vinv-ro">{{ item.fields.freight_amount | currency }}</span></div>
											<div *ngIf="item.fields.fet_amount"><label>FET</label><span class="vinv-ro">{{ item.fields.fet_amount | currency }}</span></div>
											<div><label>Invoice total</label><span class="vinv-ro vinv-ro--strong">{{ item.fields.total_amount | currency }}</span></div>
											<div *ngIf="item.fields.vendor_remit_to" class="vinv-fields--wide"><label>Remit to</label><span class="vinv-ro">{{ item.fields.vendor_remit_to }}</span></div>
										</div>
									</section>

									<!-- Lines to post (matched GRNs) + manual add -->
									<section class="vinv-section">
										<div class="vinv-section__title">
											<mat-icon>inventory</mat-icon> Lines to post
											<button type="button" class="cmi-link vinv-section__action" *ngIf="item.vendor" (click)="vinvOpenNoPo(item)" matTooltip="Create a PO + GRN from this vendor's no-PO receipts (for invoices with no purchase order)">
												<mat-icon>note_add</mat-icon> No-PO items
											</button>
										</div>
										<div class="vinv-warn-line" *ngIf="item.unmatched.length">
											<mat-icon>warning</mat-icon> No open GRN auto-matched for: <strong>{{ item.unmatched.join(', ') }}</strong> — add it below, or
											<button type="button" class="cmi-link" *ngIf="item.vendor" (click)="vinvOpenNoPo(item)">create a PO/GRN for no-PO receipts</button>.
										</div>
										<table class="vinv-table" *ngIf="item.grns.length">
											<thead>
												<tr><th>Item</th><th>GRN · PO · SO</th><th class="num">Recd</th><th class="num">Qty</th><th class="num">Our price</th><th class="num">Their price</th><th class="num">Line</th><th></th></tr>
											</thead>
											<tbody>
												<tr *ngFor="let g of item.grns">
													<td><strong>{{ g.itemcode }}</strong><br><small>{{ g.itemdescription }}</small></td>
													<td><small>GRN {{ g.grnno }} · PO {{ g.orderno }}<span *ngIf="g.jobref"> · SO {{ g.jobref }}</span></small></td>
													<td class="num">
															<span [class.vinv-warn]="vinvGrnZeroRecd(g)">{{ g.qtyrecd }}</span>
															<mat-icon class="vinv-recd-warn" *ngIf="vinvGrnZeroRecd(g)" matTooltip="This GRN shows 0 received — the goods value posts to the qty-variance account, not GRN clearing. You can still post it.">warning</mat-icon>
														</td>
													<td class="num">
															<input class="vinv-mini" [class.vinv-mini--warn]="vinvGrnUnderInvoiced(g)" [value]="g.toinvoice" (input)="vinvSetQty(item, g, $event)">
															<mat-icon class="vinv-recd-warn" *ngIf="vinvGrnUnderInvoiced(g)" [matTooltip]="'Billing ' + g.toinvoice + ' of ' + vinvGrnOpenQty(g) + ' received — ' + (vinvGrnOpenQty(g) - g.toinvoice) + ' will stay open in GRN suspense. Confirm this is a partial invoice.'">warning</mat-icon>
															<mat-icon class="vinv-split-ok" *ngIf="vinvGrnSplit(g)" [matTooltip]="'GRN split across ' + vinvGrnSharedCount(g.grnno) + ' invoices in this batch — ' + vinvGrnBatchBilled(g.grnno) + ' of ' + vinvGrnOpenQty(g) + ' billed' + (vinvGrnSplitFilled(g) ? ' (fully filled)' : '')">call_split</mat-icon>
														</td>
													<td class="num vinv-ourprice" [matTooltip]="'Our PO / receipt price'">{{ g.poUnitPrice != null ? (g.poUnitPrice | currency) : '—' }}</td>
													<td class="num">
														<input class="vinv-mini" [class.vinv-mini--pricediff]="vinvPriceDiffers(g)" [value]="g.unitprice" (input)="vinvSetPrice(item, g, $event)"
															[matTooltip]="vinvPriceDiffers(g) ? 'Their invoice price differs from our PO price (' + (g.poUnitPrice | number:'1.2-2') + ')' : ''">
														<mat-icon class="vinv-recd-warn" *ngIf="vinvPriceDiffers(g)" matTooltip="Invoice price differs from our PO price — posts a purchase-price variance">attach_money</mat-icon>
															<button mat-icon-button class="vinv-accept" *ngIf="vinvPriceDiffers(g)" (click)="vinvAcceptPrice(item, g)" matTooltip="Accept their price &amp; update the PO line (our price was entered wrong)"><mat-icon>check_circle</mat-icon></button>
													</td>
													<td class="num vinv-linetot" [class.vinv-linetot--bad]="vinvLineMismatch(item, g)">{{ (g.unitprice || 0) * (g.toinvoice || 0) | currency }}<small class="vinv-linefet" *ngIf="vinvLineFet(g) > 0">+ FET {{ vinvLineFet(g) | currency }}</small><mat-icon class="vinv-recd-warn" *ngIf="vinvLineMismatch(item, g)" [matTooltip]="'Invoice shows ' + (vinvInvExtForLine(item, g) | currency) + ' for this item — entered ' + ((g.unitprice || 0) * (g.toinvoice || 0) | currency)">report_problem</mat-icon></td>
													<td><button mat-icon-button class="vinv-rm" (click)="vinvRemoveGrn(item, g)" matTooltip="Remove line"><mat-icon>close</mat-icon></button></td>
												</tr>
											</tbody>
										</table>
										<div class="vinv-totals" *ngIf="item.grns.length">
											<span>Goods <b>{{ vinvTotals(item).subtotal | currency }}</b></span>
											<span *ngIf="vinvTotals(item).fet" class="vinv-totals__fet">FET <b>{{ vinvTotals(item).fet | currency }}</b></span>
											<span *ngIf="vinvTotals(item).taxes">Tax <b>{{ vinvTotals(item).taxes | currency }}</b></span>
											<span class="vinv-totals__sum">Entered <b>{{ vinvTotals(item).total | currency }}</b></span>
											<span class="vinv-muted">Invoice <b>{{ item.fields.total_amount | currency }}</b></span>
											<span class="vinv-totals__diff" [ngClass]="vinvReconciles(item) ? 'ok' : 'warn'">Δ <b>{{ vinvDiff(item) | currency }}</b></span>
										</div>
										<div class="vinv-mismatch" *ngIf="item.grns.length && !vinvReconciles(item)">
											<mat-icon>info</mat-icon>
											<span>{{ vinvMismatchExplain(item) }}</span>
											<label class="vinv-forcepost">
												<input type="checkbox" [checked]="item.forcePost" (change)="item.forcePost = $any($event.target).checked; persist()">
												Post anyway
											</label>
										</div>
										<div class="vinv-empty-lines" *ngIf="!item.grns.length">No GRN lines yet — search and add below.</div>

										<div class="vinv-addgrn" *ngIf="item.vendor">
											<mat-icon>add_circle_outline</mat-icon>
											<input type="text" class="vinv-addgrn-search" [(ngModel)]="vinvPoolFilter[item.id]"
												placeholder="Add a GRN line — item code, description, GRN#, PO# or SO#…" autocomplete="off">
										</div>
										<div class="vinv-pool" *ngIf="item.vendor && vinvPoolFilter[item.id]">
											<div class="vinv-pool-row" *ngFor="let g of vinvFilteredPool(item)">
												<span class="vinv-pool-code">{{ g.itemcode }}</span>
												<span class="vinv-pool-desc">{{ g.itemdescription }}</span>
												<span class="vinv-pool-meta">GRN {{ g.grnno }} · PO {{ g.orderno }}<span *ngIf="g.jobref"> · SO {{ g.jobref }}</span> · {{ (g.qtyrecd - g.quantityinv) }} left @ {{ g.unitprice | currency }}</span>
												<mat-icon class="vinv-recd-warn" *ngIf="vinvGrnZeroRecd(g)" matTooltip="0 received — will post to qty variance, not GRN clearing">warning</mat-icon>
												<button mat-stroked-button class="vinv-btn" (click)="addGrnToItem(item, g)"><mat-icon>add</mat-icon> Add</button>
											</div>
											<div class="vinv-empty-lines" *ngIf="!vinvFilteredPool(item).length">No open GRN lines match that search.</div>
										</div>
									</section>

								<!-- GL preview (after a preview) -->
									<section class="vinv-section" *ngIf="item.glPreview?.length">
										<div class="vinv-section__title"><mat-icon>account_balance</mat-icon> GL preview <span class="vinv-section__sub">preview only</span></div>
										<table class="vinv-table vinv-table--gl">
											<tbody>
												<tr *ngFor="let l of item.glPreview">
													<td class="vinv-gl-acct">{{ l.account }}</td>
													<td><small>{{ l.narrative }}</small></td>
													<td class="num">{{ l.amount | currency }}</td>
												</tr>
											</tbody>
										</table>
									</section>

										<!-- Raw / debug footer -->
										<footer class="vinv-foot">
											<span class="vinv-muted">{{ vinvPoolSize(item) }} open GRN line(s) for this vendor</span>
											<button type="button" class="cmi-link vinv-debug-toggle" (click)="item.showRaw = !item.showRaw">{{ item.showRaw ? 'Hide' : 'Show' }} raw AI</button>
										</footer>
									<pre class="vinv-raw" *ngIf="item.showRaw">{{ vinvRaw(item) }}</pre>
								</div>
							</div>
						</div>
						<ng-template #vinvEmpty>
							<div class="cmi-empty" *ngIf="vinvProcessing === 0">No invoices yet — drop vendor invoice PDFs above.</div>
						</ng-template>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Source-PDF viewer (modal — the viewer needs a sized container to render) -->
<ng-template #vinvSourceModal let-modal>
	<div class="modal-header vinv-source-head">
		<h4 class="modal-title" id="vinv-source-title"><mat-icon>picture_as_pdf</mat-icon> {{ vinvSource?.title }}</h4>
		<button type="button" class="vinv-source-close" aria-label="Close" (click)="modal.dismiss()"><mat-icon>close</mat-icon></button>
	</div>
	<div class="modal-body vinv-source-body">
		<ngx-extended-pdf-viewer *ngIf="vinvSource"
			[base64Src]="vinvSource.src"
			[page]="vinvSource.page"
			[height]="'80vh'"
			useBrowserLocale="true"
			[textLayer]="true"
			[showOpenFileButton]="false"
			[showPropertiesButton]="false"
			[showHandToolButton]="true"></ngx-extended-pdf-viewer>
	</div>
</ng-template>
